import { connect } from 'react-redux';

// components
import AddButton from './AddButton';

// action creators
import { push } from 'react-router-redux';

// selectors
import getOrganization from '../../../../lib/selectors/getOrganization';

// helpers
import getPathWithSearch from '../../../../helpers/getPathWithSearch';

const mapStateToProps = state => ({
  router:               state.get('router'),
  pnm:                  state.get('pnm'),
  vote:                 state.get('vote'),
  allowAnonymousVoting: getOrganization(state).get('allowAnonymousVoting', false),
});

const mapDispatchToProps = dispatch => ({
  navigate: (route, queryParams = {}) => {
    dispatch(push(getPathWithSearch(route, queryParams)));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddButton);
